// removed by extract-text-webpack-plugin
module.exports = {"Container":"DeleteChild__Container__VT0zl","Btn":"DeleteChild__Btn__1ab10","RedBtn":"DeleteChild__RedBtn__2q8Wq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChildController/DeleteChild/DeleteChild.css
// module id = 119
// module chunks = 0